import React from "react";
import less from "./customerSeats.module.scss";

const CustomerSeats = props => {
  const { seats, children } = props;
  return (
    <>
      <div className={less.wrapper}>
        <p>Passenger Details</p>
        <div className={less.content}>
          <div className={less.seatList}>
            {seats.map((obj, index) => (
              <div key={index} className={less.seatCard}>
                <div className={less.seatLabel}>
                  <span>{obj.seatLabel}</span>
                </div>
                <span className={less.passengerName}>{obj.name}</span>
              </div>
            ))}
          </div>
          {children}
        </div>
      </div>
    </>
  );
};

export default CustomerSeats;
